
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import { Fragment as _Fragment } from "react/jsx-runtime";
import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Head from 'next/head';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ampli } from '@aftersale-next/ampli';
import { AMPLI_ENV } from '../config/env';
import { AppProvider } from '../lib/components/app-provider';
import { SetupAtoms } from '../lib/setup-atoms';
import { SetupGtm } from '../lib/setup-gtm';
import '../resources/styles/globals.css';
import { theme } from '../theme.config';
var queryClient = new QueryClient();
ampli.load({
  environment: AMPLI_ENV
});

function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "aftersale | rastreio"
      }), /*#__PURE__*/_jsx("link", {
        rel: "shortcut icon",
        href: "/favicon.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;0,600;0,700;1,500;1,600;1,700&display=swap",
        rel: "stylesheet",
        async: true
      })]
    }), /*#__PURE__*/_jsxs(QueryClientProvider, {
      client: queryClient,
      children: [/*#__PURE__*/_jsxs(AppProvider, {
        children: [/*#__PURE__*/_jsx(SetupAtoms, {}), /*#__PURE__*/_jsxs(ChakraProvider, {
          theme: theme,
          children: [/*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps)), /*#__PURE__*/_jsx(SetupGtm, {})]
        })]
      }), /*#__PURE__*/_jsx(ReactQueryDevtools, {
        initialIsOpen: false
      })]
    })]
  });
}

const __Page_Next_Translate__ = App;

    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  